import { render, staticRenderFns } from "./AnswersType.vue?vue&type=template&id=b4574a0c&scoped=true"
import script from "./AnswersType.vue?vue&type=script&lang=js"
export * from "./AnswersType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4574a0c",
  null
  
)

export default component.exports